import { ColumnLayout, Toggle } from 'AWS-UI-Components-React';
import Popover from "@amzn/awsui-components-react-v3/polaris/popover";
import Link from "@amzn/awsui-components-react-v3/polaris/link";
import React from 'react';
import { deepClone } from '../../utilities';
import { isAdmin } from '../../utils/access-utils';
import { getJSClient } from '../js_client';
import { displayFlag, displayStatusBadge } from './simulator_utils';

export class SimulationDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      simulation: this.props.simulation || {},
      productLinesByIdMap: this.props.productLinesByIdMap || {},
      productLinesDisplay: ''
    };

  }

  componentDidMount = () => {
    this.client = getJSClient();
    this.updateProductLinesDisplay();
  }

  updateProductLinesDisplay = () => {
    // Only if productLines are selected for end to end simulation
    if (this.state.simulation['productLines'] != null) {
      let productLinesByIdMap = this.state.productLinesByIdMap;
      let productLinesDisplayName = [];
      this.state.simulation['productLines'].forEach(function (item) {
        productLinesDisplayName.push(productLinesByIdMap[item].name +'('+item+')' );
      });

      this.setState( {productLinesDisplayName : productLinesDisplayName.join(',')});
    }
  };


  updateSimulation = (event) => {
    let payload = {};
    let simulation = deepClone(this.props.simulation);
    simulation['publicView'] = event.detail.checked;
    payload['simulation'] = simulation;
    this.client.updateSimulation(() => {}, this.onUpdateSimulationFailure, payload);
  }

  onUpdateSimulationFailure = (error) => {
    console.log(error);
  };

  render() {
    const { simulation } = this.state;
    const { productLinesDisplayName } = this.state;
    const { user, latestTimestamp, endMonth, name, id, timestamp, startMonth, arn,
      stagingArea, benchmarkAdjustmentStagingArea, publicView, endToEndSimulation, hcpSimulationOutputPath, components, productLines } = simulation;
    const { loadCpData, loadDucsiData, loadFortuneData, loadLiquidationData, loadSpotData, loadVariableFcBenchmarkData } = simulation;
    const { loadCpDataMonths, loadDucsiDataMonths, loadFortuneDataMonths, loadLiquidationDataMonths, loadSpotDataMonths, loadVariableFcBenchmarkDataMonths, autoBenchmarkAdjustmentSourceLoadMonths, enableBenchmarkAdjustment, autoBenchmarkAdjustmentComponents } = simulation;
    const { syncRawData, syncAurora, runAccuracyPipeline } = simulation;

    return (
      <div className="awsui-util-container">
        <div className="awsui-util-container-header">
          <h2>Details</h2>
        </div>
        <ColumnLayout columns={ 2 } variant="text-grid">
          <div data-awsui-column-layout-root="true">
            <div>
              <div className="awsui-util-spacing-v-s">
                <div>
                  <div className="awsui-util-label">Id</div>
                  <div>{ id }</div>
                </div>
                <div>
                  <div className="awsui-util-label">Name</div>
                  <div>{ name }</div>
                </div>

                <div>
                  <div className="awsui-util-label">User</div>
                  <div>{ user }</div>
                </div>
                <div>
                  <div className="awsui-util-label">Latest Status</div>
                  <div>{ displayStatusBadge(simulation) }</div>
                </div>
                <div className="awsui-util-spacing-v-s">
                  <div>
                    <div className="awsui-util-label">Start Time</div>
                    <div>{ new Date(timestamp).toLocaleString() }</div>
                  </div>
                  <div>
                    <div className="awsui-util-label">Last Updated</div>
                    <div>{ new Date(latestTimestamp).toLocaleString() }</div>
                  </div>
                  <div>
                    {
                      arn && isAdmin(this.props.identity) && (
                        <Link
                          external
                          href={`https://us-west-2.console.aws.amazon.com/states/home?region=us-west-2#/executions/details/${ arn }`}
                        >
                          Open Step Function
                        </Link>
                      )
                    }
                  </div>
                  { (user === this.props.user || isAdmin(this.props.identity)) &&
                  <div>
                    <Toggle onChange={this.updateSimulation} checked={publicView || false}>
                      Public
                    </Toggle>
                  </div>
                  }
                </div>
              </div>
            </div>
            <div>
              <div className="awsui-util-spacing-v-s">
                <div>
                  <div className="awsui-util-label">Simulation Data Range</div>
                  <ul>
                    <li>Start Month - { startMonth }</li>
                    <li>End Month - { endMonth }</li>
                  </ul>
                </div>
              </div>
              <div className="awsui-util-spacing-v-s">
                <div>
                  <div className="awsui-util-label">Data Load Flags</div>
                  <ul>
                    { !endToEndSimulation &&
                      <li>CP Data - { displayFlag(loadCpData, 'Yes - ' + loadCpDataMonths + ' Month(s)') }</li>
                    }
                    {
                      endToEndSimulation && (
                        <React.Fragment>
                          <li>End to End Simulation - { displayFlag(endToEndSimulation) }</li>
                          <li>
                          <Popover dismissButton={false} position="top" size="small" triggerType="text"
                                   content={ components }>
                            Components
                          </Popover>
                          </li>
                          <li>
                          <Popover dismissButton={false} position="top" size="small" triggerType="text"
                                   content={ productLinesDisplayName }>
                            Product Lines
                          </Popover>
                          </li>
                          <li>
                            <Popover dismissButton={false} position="top" size="small" triggerType="text"
                              content={ hcpSimulationOutputPath }>
                              HCP Simulation Output Path
                            </Popover>
                            </li>
                        </React.Fragment>
                      )
                    }
                    <li>DUCSI Data - { displayFlag(loadDucsiData, 'Yes - ' + loadDucsiDataMonths + ' Month(s)') }</li>
                    <li>FRI Data - { displayFlag(loadFortuneData, 'Yes - ' + loadFortuneDataMonths + ' Month(s)') }</li>
                    <li>Liquidation Data - { displayFlag(loadLiquidationData, 'Yes - ' + loadLiquidationDataMonths + ' Month(s)') }</li>
                    <li>Spot Data - { displayFlag(loadSpotData, 'Yes - ' + loadSpotDataMonths + ' Month(s)') }</li>
                    <li>Variable FC Benchmark Data - { displayFlag(loadVariableFcBenchmarkData, 'Yes - ' + loadVariableFcBenchmarkDataMonths + ' Month(s)') }</li>
                  </ul>
                </div>
              </div>

              <div className="awsui-util-spacing-v-s">
                <div>
                  <div className="awsui-util-label">Execute Flags</div>
                  <ul>
                    <li>Accuracy Pipeline - { displayFlag(runAccuracyPipeline) }</li>
                    <li>Aurora Sync - { displayFlag(syncAurora) }</li>
                    <li>Raw Data Sync - { displayFlag(syncRawData) }</li>
                    {isAdmin(this.props.identity) &&
                      <li>Automate Benchmark Adjustment - { displayFlag(enableBenchmarkAdjustment === true, 'Yes - Components: ' + (autoBenchmarkAdjustmentComponents || []).join(', ') + (autoBenchmarkAdjustmentSourceLoadMonths > 0 ? ' | Source load for ' + autoBenchmarkAdjustmentSourceLoadMonths + ' Month(s)' : ' | No source load')) }</li>
                    }
                  </ul>
                </div>
              </div>

              <div className="awsui-util-spacing-v-s">
                <div>
                  <div className="awsui-util-label">Other Configuration</div>
                  <ul>
                    <li>Staged Changes - { displayFlag(stagingArea, stagingArea) }</li>
                    <li>Benchmark Adjustment Draft - { displayFlag(benchmarkAdjustmentStagingArea, benchmarkAdjustmentStagingArea) }</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </ColumnLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/simulation_details.jsx